import { farasodInstagram } from "./api"

export const addInstagramCodeRule = async (data) => {
  const response =
    await farasodInstagram.post("code-rules", data)

  return response.data
}

export const editInstagramCodeRule = async (contractId, data) => {
  const response =
    await farasodInstagram.patch(`code-rules/${contractId}`, data)

  return response.data
}

export const deleteInstagramCodeRule = async (contractId) => {
  const response =
    await farasodInstagram.delete(`code-rules/${contractId}`)

  return response.data
}